export const USERS_API_TOKEN_KEY = 'usersapitoken';
export const XAuthName = 'X-Auth-Token';
